import { Outlet, useMatch, useNavigate, useParams, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';
import { CasePartnerInterface } from '@/components/case-partner';
import { CasePartnerHistoryColumn } from '@/components/case-partner/CasePartnerHistoryColumn';

const CasePartnerPage = () => {
  const navigate = useNavigate();
  const { slug } = useParams({ from: '/matter/$slug/case-partner' });
  const chatGuid = useMatch({
    from: '/matter/$slug/case-partner/$chatGuid',
    shouldThrow: false,
  })?.params.chatGuid;
  const { documents, draft, q, docSel, web } = useSearch({ from: '/matter/$slug/case-partner' });

  const handleChatLoad = useCallback((nextChatGuid: string) => {
    if (!slug || nextChatGuid === chatGuid) return;

    navigate({
      to: '/matter/$slug/case-partner/$chatGuid',
      params: { slug, chatGuid: nextChatGuid },
      search: {},
      replace: true,
      resetScroll: false,
    });
  }, [chatGuid, navigate, slug]);

  const handleNewChat = useCallback(() => {
    if (!slug) return;

    navigate({
      to: '/matter/$slug/case-partner',
      params: { slug },
      search: {},
      replace: true,
      resetScroll: false,
    });
  }, [navigate, slug]);

  const handleNewChatDraftConsumed = useCallback(() => {
    if (!slug) return;

    navigate({
      to: '/matter/$slug/case-partner',
      params: { slug },
      search: {},
      replace: true,
      resetScroll: false,
    });
  }, [navigate, slug]);

  return (
    <div className="flex h-[calc(100vh)] overflow-hidden bg-white">
      <CasePartnerHistoryColumn
        slug={slug}
        startClosed={Boolean(q)}
        onChatLoad={handleChatLoad}
        onNewChat={handleNewChat}
      />
      <div className="min-w-0 flex-1">
        <CasePartnerInterface
          slug={slug}
          documentsSearch={documents}
          docSelSearch={docSel}
          newChatDraftRequest={draft}
          pendingQuery={q}
          pendingWebSearch={web}
          chatGuid={chatGuid}
          onNewChat={handleNewChat}
          onNewChatDraftConsumed={handleNewChatDraftConsumed}
        />
      </div>
      <Outlet />
    </div>
  );
};

export default CasePartnerPage;
